import { decodeJWT } from '@sonar-software/sonar-ts-lib';

export const isAnalyticsEnabled = (): boolean => {
	const { isSuperAdmin, isImpersonator } = decodeJWT();

	return !(isSuperAdmin || isImpersonator);
};
